<app-uig-footer-navigation
  [node]="node$ | async"
  [flyout]="false"
  [ngClass]="styleClass$ | async"
></app-uig-footer-navigation>
